/* PreNumbers Financial Builder — Cost Allocations (reskinned).
   REPLACES: src/components/FinancialBuilder/Misc/CostAllocations.jsx
   Rendered inside the Fine-tune modal. Logic unchanged. */

import { useState, useContext } from 'react';

import { FinancialBuilderContext } from '../FinancialBuilderPage.jsx';
import { genericPOSTDatabaseCall } from '../../helperFunctions.jsx';
import { costAllocationsRenderFields, industryDetails } from '../../constants.jsx';
import { renderFbField, FbIcons } from '../fbUI.jsx';

const { SaveOutlined } = FbIcons;

async function saveCompanyToDatabase(company) { return genericPOSTDatabaseCall('/api/fb/saveCompanyInfo', { company }, 'company info'); }

function CostAllocations({ contextToUse }) {
  const { companySelected, messageApi, setCompanySelected } = useContext(contextToUse || FinancialBuilderContext);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true); messageApi.loading('Saving company info...', 0);
    try {
      await saveCompanyToDatabase({ ...companySelected, id: companySelected.fb_id !== undefined ? companySelected.fb_id : companySelected.id });
      messageApi.destroy(); messageApi.success('Company info saved successfully');
    } catch (e) { console.error('Error saving company info:', e); messageApi.destroy(); messageApi.error('Failed to save company info'); }
    setSaving(false);
  };

  const handleInputChange = (event, company, key) => { setCompanySelected((prev) => ({ ...prev, [key]: event.target.value })); };
  const handleInputBlur = (event, company, key, field) => {
    let newValue = event.target.value;
    const fallback = () => (industryDetails[company.industry] ? industryDetails[company.industry][key] : field.default || '');
    if (field.regexCondition && field.errorMessage && !field.regexCondition.test(newValue)) { messageApi.error(field.errorMessage); newValue = fallback(); }
    if (newValue === '') { messageApi.error('This field cannot be empty'); newValue = fallback(); }
    setCompanySelected((prev) => ({ ...prev, [key]: newValue }));
  };

  return (
    <div className="pn-modal-embed">
      <div className="pn-fieldset">
        <div className="pn-fieldset-title">Cost allocations</div>
        <div className="pn-fields">{costAllocationsRenderFields.map((f) => renderFbField(f, companySelected, handleInputChange, true, handleInputBlur))}</div>
      </div>
      <div className="pn-editor-foot"><div className="sp" />
        <button type="button" className="pn-btn pn-btn-accent" disabled={saving} onClick={handleSave}><SaveOutlined /> Save</button>
      </div>
    </div>
  );
}

export default CostAllocations;
